import React from "react";
import { dialog, Button } from "nq-component";
import Table from "../../../../../components/Table";
import {
  countObjectUseCase,
  deleteObjectUseCase,
  findObjectUseCase,
  upsertUseCase,
} from "../../../../../usecases/object";
import { InfiniteScroll } from "nq-component";
import withRouter from "../../../../../withRouter";
import BaseListPage from "../../../../../base/BaseListPage";
import InputFactory from "../../../../../components/InputFactory";
import AdditionalTalbePresenter from "../additional-info/AdditionalTalbePresenter";
import { DialogConfirmation } from "../../../../../components/common/Converter";
import Progress from "../../../../../components/Progress";

class LearningPage extends BaseListPage {
  constructor(props) {
    super(props);
    this.presenter = new AdditionalTalbePresenter(
      this,
      findObjectUseCase(),
      countObjectUseCase(),
      deleteObjectUseCase(),
      upsertUseCase()
    );
    this.state = {
      objects: [],
      initialData: [],
      learningTitle: "",
      learningType: "",
      learningHours: "",
      learningConducted: "",
      objectID: "",
      count: 0,
      limit: 10,
      current: 1,
    };
  }

  getCurrent() {
    return this.props.object.id;
  }

  getCollectionName() {
    return "learning_development";
  }

  async componentDidMount() {
    this.presenter.componentDidMount();
    const newObject = await findObjectUseCase().execute(
      "learning_development",
      { where: { empID: this.props.object.id } }
    );
    this.setState({ initialData: newObject });
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevState.objects !== this.state.objects) {
      const initialEmails = new Set(
        this.state.initialData.map((data) => data.learningTitle)
      );
      const newObjects = this.state.objects.filter(
        (data) => !initialEmails.has(data.learningTitle)
      );
      if (newObjects.length > 0) {
        localStorage.setItem("LearningDev", JSON.stringify(newObjects));
      }
    }
  }

  // delete function
  async handleDeleteData(data) {
    // const deletedData = await findObjectUseCase().execute(
    //   "learning_development",
    //   { where: { id: id } }
    // );
    // const prevDelete = JSON.parse(localStorage.getItem("DeleteLearning")) || [];
    // const updatedDeleteData = prevDelete.concat(deletedData);
    // localStorage.setItem("DeleteLearning", JSON.stringify(updatedDeleteData));

    // await this.presenter.deleteObjectUseCase.execute(
    //   "learning_development",
    //   id
    // );
    // dialog.close();
    // this.refetchData();
    DialogConfirmation(data.id, this.getCollectionName(), () =>
      this.refetchData()
    );
  }

  onChangeForm(field, value) {
    this.setState({ [field]: value });
  }

  // edit function
  handleObjectData(object) {
    this.setState({
      objectID: object.id,
      learningTitle: object.learningTitle || "",
      learningType: object.learningType || "",
      learningHours: object.learningHours || "",
      learningConducted: object.learningConducted || "",
      learningFrom: object.from || undefined,
      learningTo: object.to || undefined,
    });
    dialog.fire({
      html: (
        <>
          <form
            onSubmit={(e) => {
              e.preventDefault();
              this.handleSaveButton();
            }}
          >
            <div className="p-2">
              <h4>Add Learning Development</h4>
              <hr />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Title of Learning and Development
                Interventions/Trainings/Programs (Write in full){" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                required
                field="learningTitle"
                defaultValue={object.learningTitle}
                // object={object}
                onChange={(value) => this.onChangeForm("learningTitle", value)}
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Type of LD (Managerial/Supervisory/Technical/etc){" "}
                <span style={{ color: "red" }}>*</span>
              </label>
              <InputFactory
                type="String"
                required
                field="learningType"
                defaultValue={object.learningType}
                // object={object}
                onChange={(value) => this.onChangeForm("learningType", value)}
              />

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Number of Hours
              </label>
              <InputFactory
                type="Number"
                field="learningHours"
                defaultValue={object.learningHours}
                // object={object}
                onChange={(value) => this.onChangeForm("learningHours", value)}
              />
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Conducted/Sponsored By
              </label>
              <InputFactory
                type="String"
                field="learningConducted"
                defaultValue={object.learningConducted}
                // object={object}
                onChange={(value) =>
                  this.onChangeForm("learningConducted", value)
                }
              />

              <div style={{ margin: "1rem 0" }}>
                <h4>Inclusive Dates of Attendance (mm/dd/yyyy)</h4>
              </div>

              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Date From
              </label>
              <InputFactory
                type="Date"
                field="learningFrom"
                object={object}
                onChange={(value) => this.onChangeForm("learningFrom", value)}
              />
              <label style={{ fontSize: "12px", paddingBottom: "10px" }}>
                Date To
              </label>
              <InputFactory
                type="Date"
                field="learningTo"
                object={object}
                onChange={(value) => this.onChangeForm("learningTo", value)}
              />

              <div className="mt-4 mb-4 d-flex justify-content-end">
                <button
                  type="button"
                  className="btn btn-light fs-sm me-3"
                  onClick={() => dialog.close()}
                >
                  Cancel
                </button>
                <button type="submit" className="btn btn-primary fs-sm me-3">
                  Save
                </button>
              </div>
            </div>
          </form>
        </>
      ),
      footer: false,
    });
  }

  async handleSaveButton() {
    if (this.state.objectID !== "") {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        learningTitle: this.state.learningTitle,
        learningType: this.state.learningType,
        learningHours: this.state.learningHours,
        learningConducted: this.state.learningConducted,
        learningFrom: this.state.learningFrom,
        learningTo: this.state.learningTo,
        id: this.state.objectID,
      };
      console.warn("DATAAA: ", this.state.objectID);
      await this.presenter.upsertUseCase.execute("learning_development", data);
      dialog.close();
      this.refetchData();
      this.setState({ objectID: "" });
    } else {
      const data = {
        email: this.props.object.email,
        empID: this.props.object.id,
        learningTitle: this.state.learningTitle,
        learningType: this.state.learningType,
        learningHours: this.state.learningHours,
        learningConducted: this.state.learningConducted,
        learningFrom: this.state.learningFrom,
        learningTo: this.state.learningTo,
      };
      console.warn("DATAAA: ", this.state.objectID);
      await this.presenter.upsertUseCase.execute("learning_development", data);
      dialog.close();
      this.refetchData();
    }
  }

  async refetchData() {
    const objects = await this.presenter.getObjects();
    this.filterSubmit({});
    return objects;
  }

  onClickPagination(page) {
    this.presenter.setCurrentPage(page);
  }

  setObjects(objects) {
    this.setState({ objects });
  }

  setCurrent(current) {
    this.setState({ current });
  }

  render() {
    const schema = this.getSchema(this.getCollectionName());
    const { objects, loading, count, current, limit } = this.state;

    if (!schema) return <Progress />;
    // const user = this.getCurrentUser();
    return (
      <>
        <div className="overflow-auto">
          <InfiniteScroll
            className="h-100"
            loadMore={this.loadMore.bind(this)}
            // hasMore={!progress && count > objects.length}
          >
            <div className="p-3 p-lg-4">
              <div
                style={{
                  marginTop: "20px",
                  width: "100%",
                }}
              >
                <div className="d-flex align-items-center justify-content-center">
                  <div style={{ marginLeft: "auto" }}>
                    <Button
                      // onClick={this.handleAddRegion.bind(this)}
                      onClick={this.handleObjectData.bind(this)}
                    >
                      <i className="bi bi-plus-lg" /> Add learningTitle
                      Development
                    </Button>
                  </div>
                </div>
              </div>

              <Table
                objectId={(data) => this.handleDeleteData(data)}
                objectData={this.handleObjectData.bind(this)}
                // editId={this.handleEditData.bind(this)}
                progress={loading}
                refetch={this.refetchData.bind(this)}
                fields={schema.fields}
                objects={objects}
                collection={schema}
                count={count}
                limit={limit}
                current={current}
                loadPagination={this.onClickPagination.bind(this)}
                actionsList={[
                  {
                    label: "Remove",
                    actionType: "delete",
                  },
                  {
                    label: "Edit",
                    actionType: "object",
                  },
                ]}
                // selectable
                // collapsable
                excludeFields={Object.keys(schema.fields).reduce(
                  (acc, key) => {
                    const options = schema.fields[key];
                    if (options.read === false) {
                      acc.push(key);
                    }
                    switch (options._type || options.type) {
                      case "Relation":
                      case "Array":
                      case "Object":
                      case "File":
                        acc.push(key);
                        break;
                      default:
                    }
                    return acc;
                  },
                  ["id", "Created At", "Updated At"]
                )}
                // selected={selected}
                // onSelect={this.onSelect.bind(this)}
                // onSelectAll={this.onSelectAll.bind(this)}
                // progress={progress}
                onClickItem={this.onClickItem.bind(this)}
              />
            </div>
          </InfiniteScroll>
        </div>
      </>
    );
  }
}

export default LearningPage;
